export default {
  employees: "Кассирлер",
  noCreatedYet: "Кассирлер әлі жасалмаған",
  downloadAppRCKassa: "RC KASSA қосымшасын жүктеп алу",
  downloadRCKassa: "RC KASSA жүктеп алу",
  addingEmployee: "Кассирді қосу",
  toCreateEmployeeNeedPoint:
    "Кассир жасау үшін кем дегенде бір сауда нүктесі қажет",
  secondName: "Кассирдің тегі",
  firstName: "Кассирдің аты",
  toTradingPoints: "Сауда нүктелеріне",
  uWantToDeleteEmployee: "Сіз шынымен кассирді өшіргіңіз келе ме?",
  personName: "Тегі және аты",
  blockAccess: "Қолжетімділікті бұғаттау",
  openAccess: "Қолжетімділікті ашу",

  employeeScore: "Кассирлерге ұпай",
  points: "ұпай",
  debiting: "Шегеру",
  accrual: "Есептеу",
};
